<template>
  <div>

    <b-navbar type="dark" variant="dark">
      <b-navbar-brand>
        <img src="@/assets/img/logo_white.png" style="max-height: 5vh;" />
      </b-navbar-brand>
    </b-navbar>
    <b-container class="mt-2">
      <b-row>
        <b-col>
          <h1>Bienvenido a Rigada Punto de Venta</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Selecciona el negocio que quieres administrar">
            <b-form-radio v-for="n in tenants" v-model="selectedTenant" name="some-radios" v-bind:key="n.id"
              :value="n.tenant_name">{{ n.name }}</b-form-radio>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox v-model="rememberTenant" name="checkbox-1" value="true" unchecked-value="false">
              Recordar mi seleccion para no regresar a esta pantalla en proximas visitas?
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button :disabled="selectedTenant.length<1" variant="success" @click="selectTenant()">Entrar</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>

</template>

<script>
import axios from "axios";
import { buildTransferUrl } from "@/utils/tokenTransfer";
export default {
  name: "SelectTenant",
  components: {},
  data() {
    return {
      tenants: [],
      selectedTenant: null,
      rememberTenant: null
    };
  },
  mounted() {
    this.selectedTenant = this.$store.getters["server/tenant"]
    this.rememberTenant = localStorage.getItem('rememberTenant')
    if (this.rememberTenant == "true" && this.selectedTenant.length > 0 && this.$route.query.override!="true") {
      this.$store.dispatch("server/changeTenantData", this.selectedTenant);
      // Check if we need to redirect to subdomain
      if (this.shouldRedirectToSubdomain(this.selectedTenant)) {
        this.redirectToTenantSubdomain(this.selectedTenant);
        return;
      }
      this.$router.push("/dashboard").catch();
    }
    this.getMyTenants()
  },
  async created() {
  },
  methods: {
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    /**
     * Check if we're on a rigadapos domain and need to redirect
     * Returns true if on rigadapos.com or rigadapos.com.mx and current subdomain doesn't match tenant
     */
    shouldRedirectToSubdomain(tenant) {
      const hostname = window.location.hostname;

      // Check if we're on a rigadapos domain
      const rigadaPattern = /^([^.]+)\.(rigadapos\.com\.mx|rigadapos\.com)$/;
      const match = hostname.match(rigadaPattern);

      if (match) {
        const currentTenant = match[1];
        // Redirect if current subdomain doesn't match selected tenant
        return currentTenant !== tenant;
      }

      // Also check for root domain without subdomain (unlikely but handle it)
      if (hostname === 'rigadapos.com.mx' || hostname === 'rigadapos.com') {
        return true;
      }

      // Not on rigadapos domain (localhost, staging, etc.) - don't redirect
      return false;
    },
    /**
     * Redirect to the tenant's subdomain preserving the current domain extension
     * Includes auth tokens in URL for seamless cross-subdomain authentication
     */
    redirectToTenantSubdomain(tenant) {
      const hostname = window.location.hostname;
      let newHostname;

      // Determine which domain extension we're on
      if (hostname.endsWith('.rigadapos.com.mx') || hostname === 'rigadapos.com.mx') {
        newHostname = `${tenant}.rigadapos.com.mx`;
      } else if (hostname.endsWith('.rigadapos.com') || hostname === 'rigadapos.com') {
        newHostname = `${tenant}.rigadapos.com`;
      } else {
        // Fallback - shouldn't happen if shouldRedirectToSubdomain returned true
        return;
      }

      // Build the new URL preserving protocol and going to dashboard
      const protocol = window.location.protocol;
      const baseUrl = `${protocol}//${newHostname}/dashboard`;

      // Build URL with auth transfer data for seamless cross-subdomain auth
      const transferUrl = buildTransferUrl(baseUrl);

      // Redirect to the new subdomain with auth data
      window.location.href = transferUrl;
    },
    selectTenant() {
      if(this.selectedTenant.length<1){
        this.$bvModal.msgBoxOk('Debes seleccionar al menos un negocio que desees operar', {
          title: 'Error',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
        return
      }
      localStorage.setItem('rememberTenant',this.rememberTenant)
      this.$store.dispatch("server/changeTenantData", this.selectedTenant);

      // Check if we need to redirect to subdomain
      if (this.shouldRedirectToSubdomain(this.selectedTenant)) {
        this.redirectToTenantSubdomain(this.selectedTenant);
        return;
      }

      // If not redirecting (localhost/dev), continue with normal flow
      axios.defaults.baseURL = this.$backDomain + localStorage.getItem('tenant')
      this.$router.push("/dashboard").catch();

    },
    getMyTenants() {
      let that = this
      axios.get(this.$backDomain + "user/tenants")
        .then(function (res) {
          that.tenants = res.data
          if(res.data.length==1){
            //that.selectedTenant=res.data[0].tenant_name
            that.selectTenant()
          }
        })
        .catch(function (err) {
          console.error(err)
          console.log(err.response)
        })
    }
  },
};
</script>